import { Component } from '@angular/core';

@Component({
  selector: 'gmo-video-views',
  imports: [],
  templateUrl: './video-views.html',
  styleUrl: './video-views.scss',
})
export class VideoViews {

}
